import { useSnackbar } from 'notistack';
import { loadingActions } from 'features';
import { supplierService } from 'services/api';
import { useAppDispatch } from 'app/store';
import TenantPage from 'components/common/TenantPage';
import { useTranslation } from 'react-i18next';
import SupplierForm from '../SupplierForm';
import { ISupplier } from 'interfaces';
import {
  DEFAULT_DOCUMENT_FLOW,
  DEFAULT_ORDER_SEND_FORMAT,
  DEFAULT_RECEPTION_FORMAT
} from 'constants/supplierIntegration';

const initSupplier: ISupplier = {
  id: 0,
  code: '',
  description: '',
  company_name: '',
  email: '',
  document_flow: DEFAULT_DOCUMENT_FLOW,
  order_send_format: DEFAULT_ORDER_SEND_FORMAT,
  reception_format: DEFAULT_RECEPTION_FORMAT
};
export const AddSupplier = () => {
  const translationPrefix = 'pages.supplier.new';
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const createSupplier = async (values) => {
    dispatch(loadingActions.startLoading());
    supplierService.add(values).then((res) => {
      enqueueSnackbar('Fornitore aggiunto con successo');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <SupplierForm supplier={initSupplier} onSubmit={createSupplier} />
    </TenantPage>
  );
};

export default AddSupplier;
